import { createAction } from "redux-actions";
import { SEND_EMAIL_WITH_VOUCHER } from "../constants";
import { feathersCreateData } from "../services";

export const sendEmailWithVoucher = createAction(SEND_EMAIL_WITH_VOUCHER, (data) => feathersCreateData('resend-voucher', data)());